import * as maptalks from 'maptalks'
import { ThreeLayer } from 'maptalks.three'
import apiMap from '../api/map'

export const createMap = async ({ id, options }) => {

  // const { data: { baseUrl } } = await apiMap.getBaseLayer()

  return new maptalks.Map(id, {
    baseLayer: new maptalks.TileLayer('base', {
      // urlTemplate: baseUrl,
      // urlTemplate: 'https://cloudgis.mn/map/v1/tilemap/std/{z}/{x}/{y}?ssid=96sl5s42b68b66jmsmt4uot1j6',
      // urlTemplate: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
      urlTemplate: 'http://b.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
      // urlTemplate: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // urlTemplate: 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
      // urlTemplate: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
      // urlTemplate: 'http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
      // urlTemplate: 'http://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
      // urlTemplate: 'https://{s}.tile.thunderforest.com/spinal-map/{z}/{x}/{y}.png',
      // urlTemplate: 'https://tile.thunderforest.com/spinal-map/{z}/{x}/{y}.png?apikey=c3fd8b0c70af4d498c4845aaf716de66',
      // urlTemplate: 'https://tile.thunderforest.com/pioneer/{z}/{x}/{y}.png?apikey=c3fd8b0c70af4d498c4845aaf716de66',
      // urlTemplate: 'https://tile.thunderforest.com/transport-dark/{z}/{x}/{y}.png?apikey=c3fd8b0c70af4d498c4845aaf716de66',
      subdomains: ['a', 'b', 'c', 'd'],
      // opacity: 0.75,
      // cssFilter: 'sepia(50%) invert(100%)',
      attribution: 'Erdenet - Bus GPS'
    }),
    ...options
  })
}

export const createMarker = ({ coordinates, options }) => new maptalks.Marker(coordinates, options)

export const createLabel = ({ label, coordinates, options }) => new maptalks.Label(label, coordinates, options)

export const createVectorLayer = ({ name = 'vector', options } = {}) => new maptalks.VectorLayer(name, options)

export const createCircleLayer = ({ center, radius, options }) => new maptalks.Circle(center, radius, options)

export const createLineStringLayer = ({ coordinates, options }) => new maptalks.LineString(coordinates, options)

export const createThreeLayer = ({ name = 'three' } = {}) => new ThreeLayer(name)

export const createTextBox = ({ content = '', coordinates, width = 100, height = 20, options }) => new maptalks.TextBox(content, coordinates, width, height, options)
